module.exports = __webpack_public_path__ + "img/juZZap-filled-white-100H.5929e798.svg";